import React, {useState} from "react";
import Column from "@amzn/meridian/column";
import Heading from "@amzn/meridian/heading"
import Row from "@amzn/meridian/row";
import WorkcellPackageHistory from "./WorkcellPackageHistory";
import { generateBreadCrumb } from "../BreadCrumbsUtils";
import { FormattedMessage } from "react-intl";
import RefreshTimer from "../../../commons/RefreshTimer";

export const WorkcellDetailsView = (props) => {
    const [updated, setUpdated] = useState(null);
    let timezoneOffsetInMilliseconds = new Date().getTimezoneOffset() * 60 * 1000;
    let startDate = props.startDate ? 'from ' + new Date(props.startDate - timezoneOffsetInMilliseconds).toISOString().substr(0, 10) : '';
    let endDate = props.endDate ? 'to ' + new Date(props.endDate - timezoneOffsetInMilliseconds - (60 * 60 * 24 * 1000)).toISOString().substr(0, 10) : '';

    return (
        <div>
            <Column widths={["grid-5"]} spacingInset="large">
                { generateBreadCrumb(props.previousPath, "Workcell Detail") }
                <Row spacingInset="none none medium">
                    <Heading level={2}><FormattedMessage id="search.workcell.detail.headerPrefix" defaultMessage="Packages scanned by "/>{props.workcellId} {startDate} {endDate}</Heading>
                </Row>
                <RefreshTimer deps={[updated]}/>
                <WorkcellPackageHistory setUpdated = {setUpdated} previousPath = {props.previousPath} workcellId = {props.workcellId} startDate = {props.startDate} endDate = {props.endDate}/>
            </Column>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/detailPages/workcellDetails/WorkcellDetailsView.js